const Mixins = {
    head: {
        title: function () {
            return {
                inner: this.$store.state.headDOM.title || ''
            };
        },
        meta: function () {
            return [
                { name: 'description', content: this.$store.state.headDOM.description || '' },
                { name: 'keywords', content: this.$store.state.headDOM.keywords || '' }
            ];
        }
    },
    methods: {
        setTitle(title) {
            this.$store.commit('updateHeadDOM', title);
            this.$emit('updateHead');
        }
    }
};

export default Mixins;
